function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 172.999,
  cy: 138,
  fill: "#edebdc",
  r: 90
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m160.999 142c0 11.046-3.582 20-8 20s-8-8.954-8-20 8-20 8-20 8 8.955 8 20z",
  fill: "#d9be6f"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m152.999 166c-8.244 0-12-12.441-12-24 0-12.428 8.648-22.252 9.018-22.664 1.516-1.699 4.449-1.699 5.965 0 .369.412 9.018 10.236 9.018 22.664-.001 11.559-3.757 24-12.001 24zm.215-7.964h.041zm-.215-29.106c-1.898 3.213-4 7.932-4 13.07 0 9.389 2.691 14.869 4 15.9 1.309-1.031 4-6.512 4-15.9 0-5.138-2.101-9.855-4-13.07z",
  fill: "#4c241d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m184.999 146c0 11.046-3.582 20-8 20s-8-8.954-8-20 8-20 8-20 8 8.955 8 20z",
  fill: "#d9be6f"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m176.999 170c-8.244 0-12-12.441-12-24 0-12.428 8.648-22.252 9.018-22.664 1.516-1.699 4.449-1.699 5.965 0 .369.412 9.018 10.236 9.018 22.664-.001 11.559-3.757 24-12.001 24zm.215-7.964h.041zm-.215-29.106c-1.898 3.213-4 7.932-4 13.07 0 9.389 2.691 14.869 4 15.9 1.309-1.031 4-6.512 4-15.9 0-5.138-2.101-9.855-4-13.07z",
  fill: "#4c241d"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m212.995 158c-.6 0-1.211-.135-1.785-.422-1.977-.988-2.777-3.391-1.789-5.367l4-8c.988-1.975 3.387-2.781 5.367-1.789 1.977.988 2.777 3.391 1.789 5.367l-4 8c-.701 1.403-2.113 2.211-3.582 2.211z",
  fill: "#4c241d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m227.79 171.233c-1.021 0-2.041-.389-2.822-1.166-1.564-1.559-1.57-4.09-.012-5.656l5.209-5.232c1.559-1.564 4.09-1.572 5.656-.012 1.564 1.559 1.57 4.09.012 5.656l-5.209 5.232c-.781.785-1.806 1.178-2.834 1.178z",
  fill: "#4c241d"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m136.999 146c0 11.046-3.582 20-8 20s-8-8.954-8-20 8-20 8-20 8 8.955 8 20z",
  fill: "#d9be6f"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m128.999 170c-8.244 0-12-12.441-12-24 0-12.428 8.648-22.252 9.018-22.664 1.516-1.699 4.449-1.699 5.965 0 .369.412 9.018 10.236 9.018 22.664-.001 11.559-3.757 24-12.001 24zm.215-7.964h.041zm-.215-29.106c-1.898 3.213-4 7.932-4 13.07 0 9.389 2.691 14.869 4 15.9 1.309-1.031 4-6.512 4-15.9 0-5.138-2.101-9.855-4-13.07z",
  fill: "#4c241d"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m66.999 76h-23c-4.971 0-9-4.029-9-9 0-1.947.632-3.842 1.8-5.4l10.527-14.036c3.572-4.761 9.176-7.564 15.128-7.564h9.722c14.814 0 26.823 12.01 26.823 26.823v58.313c0 10.418 8.446 18.864 18.864 18.864h64.819c31.103 0 56.317 25.214 56.317 56.317v25.683s10 32 26 40c0 0-34-2-46-34h-65.517c-47.763 0-86.483-38.72-86.483-86.483z",
  fill: "#a9ba5a"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m265.001 270c-.078 0-.158-.002-.236-.008-1.455-.084-34.932-2.42-48.469-33.992h-62.814c-49.893 0-90.482-40.59-90.482-90.482v-65.518h-19c-7.168 0-13-5.832-13-13 0-2.795.924-5.566 2.602-7.801l10.525-14.035c4.304-5.738 11.156-9.164 18.327-9.164h9.723c16.996 0 30.822 13.826 30.822 30.822v58.314c0 8.195 6.668 14.863 14.863 14.863h64.82c33.258 0 60.316 27.059 60.316 60.316v25.061c2.879 8.885 12.193 31.248 23.789 37.045 1.699.85 2.566 2.775 2.076 4.611-.469 1.759-2.061 2.968-3.862 2.968zm-202.547-226c-4.668 0-9.127 2.23-11.93 5.965l-10.525 14.035c-.645.859-1 1.926-1 3 0 2.758 2.242 5 5 5h23c2.209 0 4 1.791 4 4v69.518c0 45.48 37.002 82.482 82.482 82.482h65.518c1.668 0 3.16 1.035 3.746 2.596 6.039 16.104 18.227 23.992 28.008 27.832-9.705-12.75-15.26-30.232-15.572-31.234-.121-.387-.182-.789-.182-1.193v-25.684c0-28.848-23.469-52.316-52.316-52.316h-64.82c-12.607 0-22.863-10.256-22.863-22.863v-58.315c-.001-12.584-10.239-22.823-22.823-22.823z",
  fill: "#4c241d"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m64.999 80c-2.209 0-4-1.791-4-4s1.791-4 4-4c7.719 0 14-6.281 14-14 0-2.209 1.791-4 4-4s4 1.791 4 4c0 12.131-9.869 22-22 22z",
  fill: "#4c241d"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m166.999 186v12.933c0 11.635 9.432 21.067 21.067 21.067h2.933v24.5s-22 3.9-22 19.5h32.513c9.658 0 17.487-7.829 17.487-17.487v-44.913",
  fill: "#a9ba5a"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m201.511 268h-32.512c-2.209 0-4-1.791-4-4 0-14.791 15.121-20.721 22-22.654v-17.367c-13.33-.561-24-11.58-24-25.045v-12.934c0-2.209 1.791-4 4-4s4 1.791 4 4v12.934c0 9.41 7.656 17.066 17.066 17.066h2.934c2.209 0 4 1.791 4 4v24.5c0 1.934-1.391 3.592-3.295 3.938-.164.029-14.494 2.732-17.959 11.562h27.766c7.438 0 13.488-6.051 13.488-13.488v-44.912c0-2.209 1.791-4 4-4s4 1.791 4 4v44.912c0 11.85-9.638 21.488-21.488 21.488z",
  fill: "#4c241d"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m146.999 194v2c0 8.837-7.163 16-16 16v36.613c0 8.498-6.889 15.387-15.387 15.387h-26.613s6-20 22-20v-44",
  fill: "#a9ba5a"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  fill: "#4c241d"
}, /*#__PURE__*/React.createElement("path", {
  d: "m115.613 268h-26.614c-1.264 0-2.455-.598-3.209-1.611-.756-1.016-.986-2.326-.623-3.537.26-.865 6.096-19.699 21.832-22.504v-40.348c0-2.209 1.791-4 4-4s4 1.791 4 4v44c0 2.209-1.791 4-4 4-8.18 0-13.309 6.947-15.955 12h20.568c6.279 0 11.387-5.107 11.387-11.387v-36.613c0-2.209 1.791-4 4-4 6.617 0 12-5.383 12-12v-2c0-2.209 1.791-4 4-4s4 1.791 4 4v2c0 9.658-6.883 17.74-16 19.598v33.016c0 10.689-8.697 19.386-19.386 19.386z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m87.292 45.831c-.816 0-1.641-.248-2.352-.768-1.785-1.299-2.178-3.801-.877-5.588l5.703-7.83c1.299-1.783 3.799-2.182 5.588-.877 1.785 1.299 2.178 3.801.877 5.588l-5.703 7.83c-.781 1.074-1.999 1.645-3.236 1.645z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m97.212 53.268c-1.068 0-2.137-.426-2.924-1.271-1.508-1.615-1.42-4.146.195-5.652l7.787-7.268c1.609-1.508 4.145-1.42 5.652.195s1.42 4.146-.195 5.652l-7.787 7.268c-.769.721-1.749 1.076-2.728 1.076z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m110.999 128h-12c-2.209 0-4-1.791-4-4s1.791-4 4-4h12c2.209 0 4 1.791 4 4s-1.791 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m110.999 112h-12c-2.209 0-4-1.791-4-4s1.791-4 4-4h12c2.209 0 4 1.791 4 4s-1.791 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m110.999 96h-12c-2.209 0-4-1.791-4-4s1.791-4 4-4h12c2.209 0 4 1.791 4 4s-1.791 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m110.999 80h-12c-2.209 0-4-1.791-4-4s1.791-4 4-4h12c2.209 0 4 1.791 4 4s-1.791 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m110.999 64h-12c-2.209 0-4-1.791-4-4s1.791-4 4-4h12c2.209 0 4 1.791 4 4s-1.791 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m198.939 150.473c-.02 0-.039 0-.059 0-2.209-.031-3.975-1.848-3.943-4.057l.125-8.945c.031-2.209 1.807-4.01 4.057-3.943 2.209.031 3.975 1.848 3.943 4.057l-.125 8.945c-.031 2.189-1.817 3.943-3.998 3.943z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60.999,
  cy: 54,
  r: 2.932
}));

function SvgDino10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dino14",
    enableBackground: "new 0 0 300 300",
    height: 512,
    viewBox: "0 0 300 300",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDino10);
export default __webpack_public_path__ + "static/media/dino-10.e4e92ab9.svg";
export { ForwardRef as ReactComponent };